import { render, staticRenderFns } from "./ListArt.vue?vue&type=template&id=30f28e00&"
import script from "./ListArt.vue?vue&type=script&lang=js&"
export * from "./ListArt.vue?vue&type=script&lang=js&"
import style0 from "./ListArt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports